import styled from 'styled-components'

export const GlobalSearchListItemIconStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: ${(props) => props.theme.typography.pxToRem(48)};
  height: ${(props) => props.theme.typography.pxToRem(48)};
  border-radius: ${(props) => props.theme.shape.borderRadius}px;
  background: ${(props) => props.theme.colors.content.secondaryBorder};
`
